import { EmployeeType, SalaryType } from "winslow-core"

export const EmployeeTypeDisplayNames = {
    [EmployeeType.US_FULL_TIME]: 'Full Time Worker',
    [EmployeeType.US_PART_TIME]: 'Part Time Worker',
    [EmployeeType.US_CONTRACTOR]: 'Contractor',
    [EmployeeType.US_VENDOR]: 'Vendor',
    [EmployeeType.INT_FULL_TIME]: 'International Full Time Worker',
    [EmployeeType.INT_CONTRACTOR]: 'International Contractor',
}

// export const SalaryTypeDisplayNames = {
//     [SalaryType.ANNUAL]: 'Annual',
//     [SalaryType.HOURLY]: 'Hourly',
// }

export const ESSENTIAL_DESCRIPTIONS = {
    employeeType: 'Employee Type Description',
    workEmail: 'Work Email Description',
    avatarURL: 'Profile Picture Description',
    firstName: 'First Name Description',
    lastName: 'Last Name Description',
    title: 'Title Description',
    personalEmail: 'Personal Email Description',
    address: 'Address Description',
    managerId: 'Manager Description',
    personalPhone: 'Personal Phone Description',
    salaryType: 'Salary Type Description',
    salaryRate: 'Salary Rate Description',
    department: 'Department Description',
    office: 'Office Description',
    designation: 'Designation Description',
    daysOfWork: 'Days of Work Description',
    startDate: 'Start Date Description',    
    birthDate: 'Birth Date Description',
}

export const DEFAULT_NEW_EMPLOYEE_RECORD = {
    avatarURL: undefined,
    workEmail: "",
    // firstName: "",
    // lastName: "",
    // title: "",
    // personalEmail: "",
    // address: "",
    // managerId: undefined,
    // personalPhone: "",
    // salaryType: SalaryType.ANNUAL,
    // salaryRate: 0,
    // departmentId: undefined,
    // officeId: undefined,
    // designationId: undefined,
    // daysOfWork: "Mon,Tue,Wed,Thu,Fri",
    // startDate: new Date(),
    customProperties: "[]",
}
